/* ============================================================================
   Night Operators HEAT / VIPER add-on rows (assets/hv-addons.js)
   Branch HEAT-VIPER-ADDONS, 2026-09-04. No framework, no build step.

   Loaded (defer) by the add-on custom_liquid block inside the main-product
   section of templates/product.dual.json.

   THIS IS NOT THE PREDATOR KIT ENGINE. assets/predator-kit.js owns a kit state
   machine: tiers, a free bridge claim, a drop lock countdown and a rewritten
   theme price block. This page has none of that. Its own KIT OPTIONS variant
   picker (VIPER KIT, 2X VIPER BRIDGE, HEAT KIT, HEAT & VIPER BRIDGE) is the
   product choice and it stays exactly as the theme built it, price block
   included. So this file was written fresh against the same DOM grammar rather
   than the PREDATOR file being reused, which is what the brief asked for.

   What it owns, and only this:
     1. each add-on row's tick state and its variant selects
     2. the theme's own Add to cart button, intercepted so the MAIN VARIANT plus
        every ticked add-on go into ONE /cart/add.js call
     3. nothing else. It does not touch the theme price, the variant picker, the
        quantity field or the buy it now button.

   HOW THE MAIN VARIANT IS FOUND. The theme keeps the chosen variant in a hidden
   input.product-variant-id inside the product form and rewrites it whenever the
   KIT OPTIONS picker changes. This file reads that input AT PRESS TIME, never at
   load, so whatever the customer last picked is what ships. If the input cannot
   be found or carries no id, the interception STANDS DOWN and lets the theme's
   own submit run, so a theme change can degrade this block to plain behaviour
   instead of breaking the only buy button on the page.

   DISCOUNTS. The two theme product_upsell blocks this replaces applied no
   discount (measured on the live page 2026-09-04: neither rendered an
   upsell__price element). So no discount is applied here either. Prices and
   compare at prices are the listing's own, printed from the variant data Liquid
   rendered, and any automatic discount in Shopify still applies at the cart as
   it did before, because the line items are the same line items.

   No em dashes, no en dashes anywhere in this file.
   ========================================================================== */
(function () {
  'use strict';
  if (window.NOHVAddons) return;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* Money. The variant data Liquid renders carries integer cents, the same as
     the .js storefront endpoint, so both shapes divide by 100. A value that is
     already a float under 500 would be a dollar figure, which neither source
     produces; the guard exists so a hand edited fixture cannot silently render
     a price a hundred times too large. */
  function cents(v) {
    var p = Number(v);
    if (!isFinite(p)) return 0;
    return p > 500 ? p / 100 : p;
  }
  function fmt(n) {
    return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* ---------------------------------------------------------------- state */
  // rows: { key, el, input, data, variants, selects, current() }
  var rows = [];
  var subs = [];

  function selected() {
    var out = [];
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      if (!r.input || !r.input.checked || r.input.disabled) continue;
      var v = r.current();
      if (v && v.available) out.push({ key: r.key, id: v.id, price: cents(v.price), title: r.data.title || '', variant: v });
    }
    return out;
  }
  /* 53A: ticked rows whose current pick cannot be bought */
  function blocked() {
    var out = [];
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      if (!r.input || !r.input.checked || r.input.disabled) continue;
      var v = r.current();
      if (!(v && v.available)) out.push(r.data.title || r.key);
    }
    return out;
  }
  function emit() {
    var s = selected();
    for (var i = 0; i < subs.length; i++) { try { subs[i](s); } catch (e) { if (window.console) console.error('[no-hv] subscriber', e); } }
  }

  /* ------------------------------------------------------------ one row */
  /* Builds the theme styled selects for a row that has real variant options and
     wires the tick, the price, the compare at and the out of stock note. A row
     whose product has a single "Default Title" variant (the GEN I helmet
     outside the US) renders no selects at all, because there is nothing to
     choose, and behaves identically otherwise. */
  function bindRow(el, tpl) {
    var key = el.getAttribute('data-hv-row');
    var dataEl = $('script[data-hv-data]', el);
    var data = null;
    try { data = JSON.parse(dataEl ? dataEl.textContent : 'null'); } catch (e) { data = null; }
    if (!data || !data.variants || !data.variants.length) { el.hidden = true; return null; }

    var variants = data.variants.filter(function (v) { return v && v.id; });
    if (!variants.length) { el.hidden = true; return null; }

    /* Liquid's `product.options | json` inside a custom_liquid block gives an
       array of STRINGS, while the /products/x.js endpoint gives objects with a
       name. Both shapes are handled so the harness and the live page agree.
       Measured on the PREDATOR block 2026-09-04. */
    var optionNames = (data.options || []).map(function (o) {
      return typeof o === 'string' ? o : (o && o.name) || '';
    });

    /* 53A (2026-10-19). The GEN II helmet is sold VENTED only (Bon 2026-10-14);
       the solid shells are held at 0 for good. Offering them here made the row
       open on a sold out pick, so only the vented variants are kept. */
    if (key === 'helmet') {
      var iShell = optionNames.map(function (n) { return String(n).toUpperCase(); }).indexOf('SHELL');
      if (iShell >= 0) {
        var vented = variants.filter(function (v) { return String(v['option' + (iShell + 1)]).toUpperCase() === 'VENTED'; });
        if (vented.length) variants = vented;
      }
    }

    var input = $('input[type="checkbox"]', el);
    var optWrap = $('[data-hv-options]', el);
    var priceEl = $('[data-hv-price]', el);
    var compareEl = $('[data-hv-compare]', el);
    var note = $('[data-hv-note]', el);
    var img = $('img.hv__thumb', el);
    var selects = [];

    optionNames.forEach(function (name, i) {
      var okey = 'option' + (i + 1);
      var values = [];
      variants.forEach(function (v) { if (v[okey] && values.indexOf(v[okey]) < 0) values.push(v[okey]); });
      if (!values.length || values.length === 1) return;  // 53A: one value is no choice

      var wrap, labelEl, sel;
      if (tpl && tpl.content && tpl.content.firstElementChild) {
        wrap = tpl.content.firstElementChild.cloneNode(true);
        labelEl = wrap.querySelector('.hv__opt-label');
        sel = wrap.querySelector('select');
      }
      if (!wrap || !sel) {
        // The template is optional. If the asset failed to apply, build a bare
        // but working control rather than throwing and losing the whole row.
        wrap = document.createElement('span');
        wrap.className = 'hv__opt';
        labelEl = document.createElement('span');
        labelEl.className = 'hv__opt-label';
        wrap.appendChild(labelEl);
        sel = document.createElement('select');
        wrap.appendChild(sel);
      }
      if (labelEl) labelEl.textContent = name;
      sel.setAttribute('data-hv-opt', okey);
      sel.setAttribute('aria-label', name);
      values.forEach(function (val) {
        var o = document.createElement('option');
        o.value = val;
        o.textContent = val;
        sel.appendChild(o);
      });
      if (optWrap) optWrap.appendChild(wrap);
      selects.push({ key: okey, el: sel });
    });

    /* 53A: open on the first variant that can be bought. Before this, the row
       opened on the first value of every menu, which for the helmet was a sold
       out shell, so the tick box was greyed and a press on it did nothing. */
    var firstOk = variants.filter(function (v) { return v.available; })[0];
    if (firstOk) selects.forEach(function (s) { if (firstOk[s.key]) s.el.value = firstOk[s.key]; });

    function matchFor(overrideKey, overrideValue) {
      return variants.filter(function (v) {
        return selects.every(function (s) {
          var want = s.key === overrideKey ? overrideValue : s.el.value;
          return v[s.key] === want;
        });
      })[0] || null;
    }
    function current() { return matchFor(null, null); }

    /* Mark the option values that lead to a combination which cannot be bought
       right now, so the state is visible in the list rather than only after the
       choice. hv-addons.css dims them. */
    function markOptions() {
      selects.forEach(function (s) {
        Array.prototype.forEach.call(s.el.options, function (o) {
          var v = matchFor(s.key, o.value);
          if (v && v.available) o.removeAttribute('data-hv-oos');
          else o.setAttribute('data-hv-oos', '1');
        });
      });
    }

    function imageOf(v) {
      var fi = v.featured_image;
      if (fi && fi.src) return fi.src;
      if (typeof fi === 'string') return fi;
      return '';
    }

    function sync() {
      var v = current();
      var ok = !!(v && v.available);
      if (priceEl) priceEl.textContent = v ? fmt(cents(v.price)) : '';
      if (compareEl) {
        var cmp = v && v.compare_at_price ? cents(v.compare_at_price) : 0;
        var now = v ? cents(v.price) : 0;
        // Only a compare at that is genuinely higher than the price is a compare
        // at. Shopify lets a listing carry one equal to or below the price.
        if (cmp > now) { compareEl.textContent = fmt(cmp); compareEl.hidden = false; }
        else { compareEl.textContent = ''; compareEl.hidden = true; }
      }
      /* The row thumbnail is a CUT TRANSPARENT ASSET, not the listing image, so
         it is only swapped when the chosen variant has its own image AND the row
         is not the helmet row (whose asset is chosen by market in Liquid). The
         battery kit is the one listing here with per variant images. */
      if (img && v && key !== 'helmet') {
        var src = imageOf(v);
        if (src && img.getAttribute('data-hv-variant-img') === '1' && img.getAttribute('src') !== src) img.setAttribute('src', src);
      }
      if (note) { note.hidden = ok; note.textContent = ok ? '' : 'Sold out in that pick. Choose another option, or untick it.'; }
      /* 53A: the tick is never taken away silently any more. A ticked row whose
         pick is sold out stays ticked, says so here, and the Add to cart press
         refuses with a message (see blocked()), so nobody pays believing an
         add-on is in the order when it is not. A row with nothing buyable at all
         stays disabled, as before. */
      if (input) { input.disabled = !firstOk; }
      el.classList.toggle('is-on', !!(input && input.checked && ok));
      markOptions();
      emit();
    }

    selects.forEach(function (s) {
      s.el.addEventListener('change', sync);
      // A press on the select must not toggle the row's checkbox: the whole row
      // is a <label>, so a click inside it would otherwise reach the input.
      s.el.addEventListener('click', function (ev) { ev.stopPropagation(); });
    });
    if (input) input.addEventListener('change', sync);

    var row = { key: key, el: el, input: input, data: data, variants: variants, selects: selects, current: current, sync: sync };
    sync();
    return row;
  }

  /* ---------------------------------------------------------------- cart */
  var busy = false;

  /* 77A (2026-10-19). THE CART DRAWER'S PRESELECTED UPSELLS (shipping insurance).
     The theme's own product form puts every cart-drawer-upsell that reads
     data-selected="true" into the same add call as the main item. A buy that
     skips the theme form skipped them too, so the insurance line was lost.
     They are added here the same way: only the ones still switched on, and
     never one the cart already holds, so the line is added once, never twice. */
  function drawerExtras(already) {
    var ids = [];
    var seen = {};
    (already || []).forEach(function (x) { seen[String(x)] = 1; });
    Array.prototype.forEach.call(document.querySelectorAll('cart-drawer-upsell[data-selected="true"]'), function (u) {
      var id = Number(u.getAttribute('data-id'));
      if (id && !seen[String(id)]) { seen[String(id)] = 1; ids.push(id); }
    });
    if (!ids.length) return Promise.resolve([]);
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var have = {};
        ((c && c.items) || []).forEach(function (it) { have[String(it.variant_id)] = 1; });
        return ids.filter(function (id) { return !have[String(id)]; });
      })
      .catch(function () { return []; });
  }

  function mainVariantId(info) {
    // The theme's own hidden input, rewritten by its variant picker. Read at
    // press time so the LAST choice wins, never at load.
    var el = $('input.product-variant-id', info) || $('form[action*="/cart/add"] input[name="id"]', info);
    var v = el ? Number(el.value) : 0;
    return isFinite(v) && v > 0 ? v : 0;
  }

  function cartElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }
  function sectionIds(cart) {
    try {
      if (cart && typeof cart.getSectionsToRender === 'function') {
        return cart.getSectionsToRender().map(function (s) { return s.section || s.id; }).filter(Boolean);
      }
    } catch (e) {}
    return [];
  }

  function quantityOf(info) {
    var q = $('input[name="quantity"]', info);
    var n = q ? Number(q.value) : 1;
    return isFinite(n) && n > 0 ? Math.floor(n) : 1;
  }

  function items(info) {
    var id = mainVariantId(info);
    if (!id) return null;                       // stand down, let the theme submit
    var out = [{ id: id, quantity: quantityOf(info) }];
    selected().forEach(function (s) { out.push({ id: s.id, quantity: 1 }); });
    return out;
  }

  function addToCart(btn, info, done) {
    if (busy) return false;
    var list = items(info);
    if (!list) return false;
    busy = true;
    var payload = { items: list };
    var cart = cartElement();
    var ids = sectionIds(cart);
    if (ids.length) { payload.sections = ids.join(','); payload.sections_url = window.location.pathname; }
    if (btn) { btn.setAttribute('disabled', 'disabled'); btn.setAttribute('aria-busy', 'true'); }
    document.dispatchEvent(new CustomEvent('no-hv:adding', { detail: payload }));
    return drawerExtras(list.map(function (x) { return x.id; })).then(function (extra) {
      /* the theme puts the drawer upsells first; same order here */
      if (extra.length) payload.items = extra.map(function (id) { return { id: id, quantity: 1 }; }).concat(payload.items);
      return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    });
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body && res.body.description ? res.body.description : 'Add to cart failed');
        document.dispatchEvent(new CustomEvent('no-hv:added', { detail: res.body }));
        var opened = false;
        try {
          if (cart && typeof cart.renderContents === 'function' && res.body && res.body.sections) {
            if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(res.body);
            opened = true;
          }
        } catch (e) { opened = false; if (window.console) console.warn('[no-hv] drawer render failed, falling back to /cart', e); }
        if (window.Shopify && window.Shopify.onCartUpdate) { try { window.Shopify.onCartUpdate(); } catch (e) {} }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (!opened) window.location.href = '/cart';
        busy = false;
        if (btn) { btn.removeAttribute('disabled'); btn.removeAttribute('aria-busy'); }
        if (done) done(null, res.body);
      })
      .catch(function (err) {
        busy = false;
        if (btn) { btn.removeAttribute('disabled'); btn.removeAttribute('aria-busy'); }
        if (window.console) console.error('[no-hv] add to cart:', err);
        document.dispatchEvent(new CustomEvent('no-hv:error', { detail: String(err && err.message || err) }));
        if (done) done(err);
      });
  }

  var api = window.NOHVAddons = {
    fmt: fmt, cents: cents,
    selected: selected,
    blocked: blocked,
    rows: function () { return rows.slice(); },
    addToCart: addToCart,
    subscribe: function (fn) { subs.push(fn); fn(selected()); return function () { var i = subs.indexOf(fn); if (i >= 0) subs.splice(i, 1); }; }
  };

  /* ---------------------------------------------------------------- bind */
  function bind() {
    var root = document.getElementById('no-hv-addons');
    if (!root || root.hasAttribute('data-hv-bound')) return;
    root.setAttribute('data-hv-bound', '1');

    var tpl = $('template[data-hv-select-tpl]', root);
    var err = $('[data-hv-error]', root);

    rows = $$('[data-hv-row]', root).map(function (el) { return bindRow(el, tpl); }).filter(Boolean);

    var helmetBox = $('[data-hv-helmet]', root);
    api.helmetMarket = helmetBox ? helmetBox.getAttribute('data-hv-helmet-market') : null;
    api.helmetHandle = helmetBox ? helmetBox.getAttribute('data-hv-helmet-handle') : null;

    // The theme's own buy button. Intercepted in the CAPTURE phase, before the
    // theme's product-form listener, and only when at least one add-on is
    // ticked: with nothing ticked the theme's own submit is left alone, which
    // keeps the untouched path byte identical to today's behaviour.
    var info = root.closest('.product__info-container') || root.closest('[id^="ProductInfo-"]') || document;
    api.info = info;
    var form = $('product-form.main-product-form form, form[data-type="add-to-cart-form"]', info) || $('form[action*="/cart/add"]', info);
    var submit = form ? $('.product-form__submit, [type="submit"][name="add"]', form) : null;

    function intercept(ev, btn) {
      var bl = blocked();
      if (bl.length) {                       // 53A: never add without a ticked add-on
        ev.preventDefault();
        ev.stopImmediatePropagation();
        if (err) { err.textContent = bl.join(', ') + ' is sold out in that pick. Choose another option, or untick it.'; err.hidden = false; }
        return;
      }
      if (!selected().length) return;        // nothing added, let the theme run
      if (!mainVariantId(info)) return;      // cannot read the variant, stand down
      ev.preventDefault();
      ev.stopImmediatePropagation();
      if (err) { err.hidden = true; err.textContent = ''; }
      addToCart(btn, info, function (e) {
        if (e && err) { err.textContent = String(e.message || e); err.hidden = false; }
      });
    }

    if (submit && !submit.hasAttribute('data-hv-bound')) {
      submit.setAttribute('data-hv-bound', '1');
      submit.addEventListener('click', function (ev) { intercept(ev, submit); }, true);
    }
    if (form && !form.hasAttribute('data-hv-bound')) {
      form.setAttribute('data-hv-bound', '1');
      form.addEventListener('submit', function (ev) { intercept(ev, submit); }, true);
    }

    api.subscribe(function (s) {
      root.classList.toggle('has-addons', s.length > 0);
      if (err && !blocked().length && String(err.textContent || '').indexOf('sold out in that pick') >= 0) { err.hidden = true; err.textContent = ''; }
    });
  }

  function init() { bind(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
}());
